import { Empty } from "components/Empty";
import { FilterInput } from "components/FilterInput";
import { useField } from "lib/form";
import { device, mq } from "lib/media-query";
import React, { FC } from "react";
import styled from "styled-components";

interface TrefwordFilterProps {
    condensed?: boolean;
}

const Grid = styled.div<TrefwordFilterProps>`
    display: grid;
    grid-template-columns: 1fr 3fr;
    gap: 16px;

    ${mq.to(device.TABLET)`
     grid-template-columns: 1fr;
  `};
    ${({ condensed }) => (condensed ? "grid-template-columns: 1fr" : "")}
`;

export const TrefwoordFilter: FC<TrefwordFilterProps> = ({ condensed }) => {
    const [trefwoordValue, , onTrefwoordChange] = useField<string[]>("trefwoord");

    return (
        <Grid condensed={condensed}>
            <FilterInput
                filterId="filter-trefwoord"
                value={trefwoordValue || [""]}
                handleChange={(_, value) => onTrefwoordChange(value)}
                datalayerKey="trefwoord"
                helpText="Trefwoord"
                ariaLabel="Trefwoord"
                autoComplete="do-not-autofill"
            />
            <Empty />
        </Grid>
    );
};
